import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DocumentViewerAction} from './documentViewer.component';

@Component({
    selector: 'lv-document-viewer-toolbar',
    templateUrl: './documentViewerToolbar.component.html',
    styleUrls: ['./documentViewerToolbar.component.scss'],
    standalone: false
})
export class DocumentViewerToolbarComponent {
  @Input()
  public zoomLevel: number;
  @Output()
  public zoomLevelChange = new EventEmitter<number>();
  @Input()
  public rotation: number;
  @Output()
  public rotationChange = new EventEmitter<number>();
  @Input()
  public total: number;
  @Input()
  public actions: DocumentViewerAction[];
  @Output()
  public executeAction = new EventEmitter<DocumentViewerAction>();
  @Input()
  public current: number;
  @Output()
  public currentChange = new EventEmitter<number>();
  @Input()
  public disabled: boolean;
  @Input()
  public hidePager: boolean;
  @Input()
  public hideZoom: boolean;
  @Input()
  public hideRotation: boolean;
  @Input()
  public hideCustomActions: boolean;

  public readonly MIN_ZOOM_LEVEL = 10;
  public readonly MAX_ZOOM_LEVEL = 200;
  public readonly ZOOM_FACTOR = 10;
  public readonly ROTATION_DEG = 90;
  public readonly MIN_ROTATION_DEG = 0;
  public readonly MAX_ROTATION_DEG = 90 * 3;

  public zoom(delta: number): void {
    this.zoomLevelChange.emit(this.zoomLevel += delta);
  }

  public rotateClockwise(): void {
    const newDegree = this.rotation + this.ROTATION_DEG;
    this.rotation = newDegree > this.MAX_ROTATION_DEG ? this.MIN_ROTATION_DEG : newDegree;
    this.rotationChange.emit(this.rotation);
  }

  public rotateCounterClockwise(): void {
    const newDegree = this.rotation - this.ROTATION_DEG;
    this.rotation = newDegree < this.MIN_ROTATION_DEG ? this.MAX_ROTATION_DEG : newDegree;
    this.rotationChange.emit(this.rotation);
  }
}
